import customFetch from '../../utils/customFetch'
import { API_ENDPOINT } from '../../config'
import { RealEstateDTO } from '../../@types/real-estate-api-types'
import { RealEstatePreview } from '../../@types/preview-types'
import { realEstatePreviewResponseToApp } from './converters/realEstatePreview'

const url = API_ENDPOINT + '/anbieten/private-anbieter/inserieren/api/previewRealEstate'

export const getPreview = async (realEstateObject: RealEstateDTO): Promise<RealEstatePreview | undefined> => {
  const options = {
    method: 'POST',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    credentials: 'include',
    body: JSON.stringify(realEstateObject),
  }

  const response = await customFetch(url, options)
  if (response.status == 200) {
    return realEstatePreviewResponseToApp(await response.text())
  }

  return undefined
}
